import {LOG_OUT} from "./ActionTypes";

import KPIReportService from "../services/AgencyKPIReportService";
import {getUser} from "../utils/TokenManager";


export const getKPIReport = (locationId, startDate, endDate) => (
    async (dispatch) => {
        try {
            let result = await KPIReportService.getKPIReport(locationId, startDate, endDate);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getDepartmentList = (locationId) => (
    async (dispatch) => {
        try {
            const result = await KPIReportService.getDepartment(locationId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                return result.data.department;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getLocationCount = () => (
    async (dispatch) => {
        try {
            let result = await KPIReportService.getLocationCount();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const selectedDeptList = (locationId, selctedDeptObj={}, method="GET") => (
    async (dispatch) => {
        try {
            let result = {};
            if (method === "PUT") {
                result = await KPIReportService.putSelectedDeptList(locationId, selctedDeptObj);
            } else {
                result = await KPIReportService.getSelectedDeptList(locationId);
            }

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const generateKPIReport = (locationId, data) => (
    async (dispatch) => {
        try {
            let result = await KPIReportService.getPDF(locationId, data);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }
        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/AgencyKPIreportAction.js